import { render, staticRenderFns } from "./CenterModal.vue?vue&type=template&id=c727a264&scoped=true"
import script from "./CenterModal.vue?vue&type=script&lang=js"
export * from "./CenterModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c727a264",
  null
  
)

export default component.exports